// ##### Komarov 2025-07-18
import React from 'react';
// ##### 23-09-14 Komarov
// import './SliderCss.css'
// ##### 23-11-02 Komarov
import { Media } from '../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import SliderDiv from './SliderDiv';

// ##### Komarov 2025-07-18
const Slider = ({ slides }) => {
  return (
    <>
      {/* ##### 23-11-02 Komarov */}
      <Media lessThan="Mobile-L-425-768">
        <SliderDiv className="SliderTabletPortraitCSS" slides={slides} />
      </Media>
      <Media between={['Mobile-L-425-768', 'Laptop-1024-1440']}>
        <SliderDiv className="SliderMobilePortraitCSS" slides={slides} />
      </Media>
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <SliderDiv className="SliderCSS" slides={slides} />
      </Media>
    </>
  );
};

// ##### 25-05-02 Komarov
export default Slider;
